module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/57e6d825c90414bc6766e16d7b03df97.png";